module.exports = __webpack_public_path__ + "img/seaBomb.50de321a.png";